import { File as PlainFile, type IconProps } from '../../../design-system/icons';
import { isKnownKind, KIND_ICON } from './fileKinds';

export interface FileKindIconProps extends IconProps {
  /** The server's kind, checked rather than trusted. */
  kind: string;
}

/**
 * A file kind's glyph. A kind this build doesn't know — a newer server's, or
 * a message missing it — is drawn as a plain file rather than crashing the
 * thread.
 */
export function FileKindIcon({ kind, ...iconProps }: FileKindIconProps) {
  if (!isKnownKind(kind)) return <PlainFile {...iconProps} />;
  const Glyph = KIND_ICON[kind];
  return <Glyph {...iconProps} />;
}
